import {select} from "../../../shared/SagaService";

// ATTENTION: Only for Invoice's Applied Link Ids
// appliedLinkIds => appliedLinkItems
export function* getAppliedLinkItems() {
    const state = yield select();

    const {
        appliedLinkIds, // User-selected
        linkItems, // All available options
    } = state.Transaction;

    // Only for new Invoices
    return appliedLinkIds.map(id => {
        const linkItem = linkItems.find(item => item.target_transaction_id === id) || {};

        return {
            ...linkItem,
            origin_transaction_id: linkItem.target_transaction_id,
        };
    });
}
